//-------------------------------------
// load character characteristic props
//-------------------------------------
export default function loadCharacterCharacteristicProps(characters) {
  // console.log("------------------------------");
  // console.log("IN loadCharacterCharacteristicProps");
  //
  const char_array = ['str', 'con', 'dex', 'siz', 'int', 'pow', 'cha']
  const end_array = ['cur', 'rolled', 'improvs_tot', 'incr_percent', 'adjs_tot']
  //-----------------
  // loop characters
  //-----------------
  characters.forEach((c) => {
    //-------------------------------
    // loop chars for each character
    //-------------------------------
    char_array.forEach((char) => {
      //-------------------------
      // loop ends for each char
      //-------------------------
      end_array.forEach((e) => {
        let end = char + '_' + e
        if (!Object.hasOwn(c, end)) {
          Object.defineProperty(c, end, {
            value: false,
            writable: true,
            enumerable: true,
            configurable: true,
          })
        }
      })
    })
    //-----------------------------
    // add integs tot for pow only
    //-----------------------------
    if (!Object.hasOwn(c, 'pow_integs_tot')) {
      Object.defineProperty(c, 'pow_integs_tot', {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      })
    }
    //-----------------------------
    // add loss total for con only
    //-----------------------------
    if (!Object.hasOwn(c, 'con_wounds_tot')) {
      Object.defineProperty(c, 'con_wounds_tot', {
        value: false,
        writable: true,
        enumerable: true,
        configurable: true,
      })
    }
  })
  return characters
}
